import { useEffect } from "react";
import { Check } from "lucide-react";
import { Toaster } from "sonner";
import { Reveal } from "@/components/landing/Reveal";
import { PageHeader } from "@/components/landing/PageHeader";
import { Jobs } from "@/components/landing/Jobs";
import { Footer } from "@/components/landing/Footer";

const PERKS = [
  "Verified job opportunities", "Transparent job information", "Employer information",
  "Recruitment process guidance", "Documentation assistance", "Work-permit guidance",
  "Pre-departure assistance",
];

export default function CandidatesPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="candidates-page">
      <Toaster position="bottom-right" theme="light" toastOptions={{ style: { background: "#f4f4f5", border: "1px solid #e4e4e7", color: "#0a0a0a", borderRadius: "0" } }} />
      <PageHeader />
      <section className="pt-16 md:pt-24 pb-12 px-6 md:px-12">
        <div className="max-w-[1600px] mx-auto">
          <Reveal>
            <p className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30] mb-6">For candidates</p>
            <h1 className="font-head uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl xl:text-8xl">Live jobs.<br />Apply today.</h1>
            <p className="mt-8 font-body text-lg text-[#52525b] max-w-2xl leading-relaxed">Browse verified, live openings across Europe — including roles posted by employers in real time — and apply online through the DALIMIT GLOBAL Job Portal, our international application portal.</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-4 px-6 md:px-12">
        <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10">
          {PERKS.map((it, i) => (
            <Reveal key={it} delay={(i % 3) * 0.05}>
              <div className="flex items-start gap-3 py-4 border-b border-[#e4e4e7] font-body text-[#0a0a0a]">
                <Check size={18} className="text-[#ff3b30] shrink-0 mt-0.5" strokeWidth={2.5} />{it}
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Live job openings + apply (with CV upload) */}
      <Jobs />
      <Footer />
    </main>
  );
}
